// plugins/click-outside.ts
export default defineNuxtPlugin((nuxtApp) => {
	interface ClickOutsideElement extends HTMLElement {
		__clickOutsideHandler__?: (e: MouseEvent) => void;
	}

	nuxtApp.vueApp.directive('click-outside', {
		beforeMount(el: HTMLElement, binding) {
			const _el = el as ClickOutsideElement;

			_el.__clickOutsideHandler__ = (e: MouseEvent) => {
				const target = e.target as HTMLElement;

				if (
					_el.contains(target) ||
					document.querySelector('.v-overlay')?.contains(target) ||
					target.closest('.v-menu') ||
					target.closest('.v-overlay')
				) {
					return;
				}

				binding.value(e);
			};

			setTimeout(() => {
				document.addEventListener('click', _el.__clickOutsideHandler__!);
			}, 0);
		},

		unmounted(el: HTMLElement) {
			const _el = el as ClickOutsideElement;

			if (_el.__clickOutsideHandler__) {
				document.removeEventListener('click', _el.__clickOutsideHandler__);
				delete _el.__clickOutsideHandler__;
			}
		},
	});
});